import type { ScopeTierConsolidationProvenance } from '@/shared/hooks/api/radarScopeTier'

export function formatLegislationCorpusLabel(
  provenance: Pick<
    ScopeTierConsolidationProvenance,
    'consolidatedCelex' | 'consolidationVersionDate'
  >
): string {
  if (provenance.consolidatedCelex) {
    return provenance.consolidationVersionDate
      ? `ConsLeg (${provenance.consolidationVersionDate})`
      : 'ConsLeg'
  }
  return 'Original OJ publication'
}
